import {RawMaterialsClassificationInputNames, MaterialType} from '@domain/materials'

import {ClassificationHeaderCells} from './ClassificationHeaderCells'

import {LONG_COLUMN_WIDTH, VERY_LONG_COLUMN_WIDTH} from '@settings/modules/common/consts'

const fields = [
  {
    key: RawMaterialsClassificationInputNames.IsThermallyProcessedClinkerSubstitute,
    minWidth: VERY_LONG_COLUMN_WIDTH
  },
  {key: RawMaterialsClassificationInputNames.Category},
  {key: RawMaterialsClassificationInputNames.RawMaterialType, minWidth: LONG_COLUMN_WIDTH},
  {key: RawMaterialsClassificationInputNames.RawMaterialCategory, minWidth: LONG_COLUMN_WIDTH},
  {key: RawMaterialsClassificationInputNames.RawMaterialSubCategory, minWidth: LONG_COLUMN_WIDTH},
  {key: RawMaterialsClassificationInputNames.FormSize, minWidth: LONG_COLUMN_WIDTH},
  {key: RawMaterialsClassificationInputNames.ProcessingDegree}
]

export const RawMaterialsClassificationHeader = () => {
  return <ClassificationHeaderCells fields={fields} materialType={MaterialType.RawMaterials} />
}
